import React from 'react';
import BottomNav from '../components/BottomNav';

const PriveFineDining = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Privé Fine Dining</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Michelin-Star Experiences</p>
        
        <div className="card">
          <p>
            Indulge in exclusive fine dining experiences at the world's most prestigious restaurants. 
            Enjoy priority reservations, private chef services, and culinary journeys.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Michelin-Star Access</h3>
              <p>Priority bookings at award-winning restaurants worldwide</p>
            </div>
            <div className="feature-item">
              <h3>Private Chef Services</h3>
              <p>Personal culinary experiences in the comfort of your home</p>
            </div>
            <div className="feature-item">
              <h3>Wine Sommelier</h3>
              <p>Expert wine pairings and rare vintage access</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default PriveFineDining;
